import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import {
    IonButton,
    IonIcon,
    IonInput,
    IonPage,
    IonSpinner,
} from "@ionic/react";
import {
    personAddOutline, personOutline, idCardOutline, lockClosedOutline,
    eyeOutline, eyeOffOutline, alertCircleOutline, checkmarkCircleOutline,
} from "ionicons/icons";
import { handleRegisterNewUser } from './SendSignup';
import { AppBackground } from '../../components/PageHeader';
import '../login/login.css';

export default function Signup() {
    // Campos anteriores
    const [nickname, setNickname] = useState("");
    const [contrasena, setContrasena] = useState("");
    const [nombre, setNombre] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);
    const history = useHistory();

    const handleSignup = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);

        // Validación incluyendo los nuevos campos obligatorios
        if (!nickname || !contrasena || !nombre || !confirmPassword) {
            setError("Todos los campos son obligatorios");
            return;
        }

        if (contrasena !== confirmPassword) {
            setError("Las contraseñas no coinciden");
            return;
        }

        if (contrasena.length < 6) {
            setError("La contraseña debe tener al menos 6 caracteres");
            return;
        }

        // Estructura de datos adaptada para tu Backend
        const data = {
            nickname: nickname,
            password: contrasena,
            nombre: nombre,
            confirmPassword: confirmPassword
        };

        setLoading(true);
        try {
            await handleRegisterNewUser(data);
            setSuccess("Cuenta creada. Redirigiendo al inicio de sesión...");
            setTimeout(() => history.push('/'), 2000);
        } catch (err: any) {
            setError("Error al registrar: " + (err.message || err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <IonPage className="app-page login-page">
            <AppBackground variant="auth" />

            <div className="login-wrapper">
                <div className="login-logo">
                    <div className="logo-circle">
                        <IonIcon icon={personAddOutline} />
                    </div>
                    <h2 className="app-name">Referidos</h2>
                </div>

                <div className="login-card">
                    <h1 className="login-title">Crear cuenta</h1>
                    <p className="login-subtitle">Completa tus datos para registrarte.</p>

                    <form onSubmit={handleSignup} className="app-form">
                        <div className="input-group">
                            <span className="input-icon">
                                <IonIcon icon={personOutline} />
                            </span>
                            <IonInput
                                value={nickname}
                                placeholder="Usuario"
                                onIonInput={(e: any) => setNickname(e.detail.value ?? "")}
                                className="app-input"
                                disabled={loading}
                            />
                        </div>

                        <div className="input-group">
                            <span className="input-icon">
                                <IonIcon icon={idCardOutline} />
                            </span>
                            <IonInput
                                type="text"
                                value={nombre}
                                placeholder="Nombre completo"
                                onIonInput={(e: any) => setNombre(e.detail.value ?? "")}
                                className="app-input"
                                disabled={loading}
                            />
                        </div>

                        <div className="input-group">
                            <span className="input-icon">
                                <IonIcon icon={lockClosedOutline} />
                            </span>
                            <IonInput
                                type={showPassword ? 'text' : 'password'}
                                value={contrasena}
                                placeholder="Contraseña"
                                onIonInput={(e: any) => setContrasena(e.detail.value ?? "")}
                                className="app-input"
                                disabled={loading}
                            />
                            <span className="input-icon-right" onClick={() => setShowPassword(!showPassword)}>
                                <IonIcon icon={showPassword ? eyeOffOutline : eyeOutline} />
                            </span>
                        </div>

                        <div className="input-group">
                            <span className="input-icon">
                                <IonIcon icon={lockClosedOutline} />
                            </span>
                            <IonInput
                                type={showConfirmPassword ? 'text' : 'password'}
                                value={confirmPassword}
                                placeholder="Confirmar contraseña"
                                onIonInput={(e: any) => setConfirmPassword(e.detail.value ?? "")}
                                className="app-input"
                                disabled={loading}
                            />
                            <span className="input-icon-right" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                <IonIcon icon={showConfirmPassword ? eyeOffOutline : eyeOutline} />
                            </span>
                        </div>

                        {error && (
                            <div className="status-alert alert-error">
                                <IonIcon icon={alertCircleOutline} />
                                <span>{error}</span>
                            </div>
                        )}

                        {success && (
                            <div className="status-alert alert-success">
                                <IonIcon icon={checkmarkCircleOutline} />
                                <span>{success}</span>
                            </div>
                        )}

                        <IonButton type="submit" expand="block" className="app-btn-primary" disabled={loading}>
                            {loading ? <IonSpinner name="crescent" /> : 'Registrarse'}
                        </IonButton>

                        <p className="login-footer-link">
                            ¿Ya tienes cuenta? <Link className="app-link" to="/">Inicia sesión</Link>
                        </p>
                    </form>
                </div>
            </div>
        </IonPage>
    );
}
